import React from 'react';

type Props = {
  children?: React.ReactNode;
};

const TrGroup = ({ children }: Props) => (<>{children}</>);

export default TrGroup;
